var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-radio-group',{attrs:{"buttonStyle":"solid","size":"small"},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},_vm._l((_vm.options),function(option){return _c('a-radio-button',{key:option.value,attrs:{"value":option.value}},[_vm._v(" "+_vm._s(option.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }